import React from 'react';
import Box from '@mui/material/Box';
import { OpenAPIV3_1 as OpenAPI } from "openapi-types";
import _ from 'lodash';
import SplitPane from '../SplitPane';
import ResponseBox from '../ResponseBox';
import RequestBox from '../RequestBox';
import { httpGet } from 'src/api';

export interface GetProps {
    operationObject: OpenAPI.OperationObject;
}

const Get: React.FC<GetProps> = ({ operationObject }) => {
    const { responses } = operationObject;

    return (
        <Box>
            <SplitPane
                req={
                    <RequestBox
                        operationObject={operationObject}
                        runRequest={
                            (pathKey, pathParams, queryParams, _) => httpGet(pathKey, pathParams, queryParams)
                        }
                    />
                }
                res={<ResponseBox responsesObject={responses} />}
            />
        </Box>
    );
};

export default Get;
